"use client";

import TranslateErrorBoundary from "./TranslateErrorBoundary";

export default function TranslateErrorBoundaryWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return <TranslateErrorBoundary>{children}</TranslateErrorBoundary>;
}
